<div>
    <div class="row" *ngIf="vm.workingText">
        <div class="col-md-12">
            <div class="text-center">
                <div>{{vm.workingText}}</div>
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="vm.errorText">
        <div class="col-md-12">
            <div class="text-center danger">
                <span>{{vm.errorText}}</span>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="vm.isNotFound">
        <div class="col-md-12">
            <div class="text-center">
                <h1 class="text-success">No Data Found</h1>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="vm.requiredGroups && vm.requiredGroups.length">
        <div class="col-md-12">
            <div class="text-center danger">
                <span>Please request access to one of the following groups... </span>
                <span>{{(vm.requiredGroups || []).join(', ')}}</span>
            </div>
        </div>
    </div>

</div>